import { Palette } from '@mui/material';
import { TypographyOptions, TypographyStyleOptions } from '@mui/material/styles/createTypography';

import { breakpoints } from './breakpoints';

const fontFamily = ['Inter', 'Helvetica', 'Arial', 'sans-serif'].join(',');

export const typography: (palette: Palette) => TypographyOptions = palette => {
    const baseTypography: TypographyStyleOptions = {
        fontFamily,
        fontStyle: 'normal',
        fontWeight: 400,
    };

    const h2Base = {
        ...baseTypography,
        fontWeight: 600,
        fontSize: '2.875rem',
        lineHeight: '110%',
        letterSpacing: -0.8,
        [`@media (max-width: ${breakpoints.values.sm}px )`]: {
            fontSize: '1.75rem',
            lineHeight: '130%',
            letterSpacing: 'normal',
        },
    };

    return {
        fontFamily,
        h1: {
            ...baseTypography,
            fontWeight: 600,
            fontSize: '4.5rem',
            lineHeight: '110%',
            letterSpacing: -1.5,
            [`@media (max-width: ${breakpoints.values.sm}px )`]: {
                fontSize: '3.5rem',
                lineHeight: '120%',
                letterSpacing: -1,
            },
        },
        h2: {
            ...h2Base,
        },
        h2Uppercase: {
            ...h2Base,
            textTransform: 'uppercase',
        },
        h3: {
            ...baseTypography,
            fontWeight: 600,
            fontSize: '2.25rem',
            lineHeight: '130%',
            letterSpacing: -0.5,
            [`@media (max-width: ${breakpoints.values.sm}px )`]: {
                fontSize: '1.5rem',
                lineHeight: '130%',
                letterSpacing: 'normal',
            },
        },
        h4: {
            ...baseTypography,
            fontWeight: 600,
            fontSize: '1.75rem',
            lineHeight: '130%',
            letterSpacing: -0.3,
            [`@media only screen and (max-width: ${breakpoints.values.sm}px )`]: {
                fontSize: '1.25rem',
                lineHeight: '130%',
                letterSpacing: 'normal',
            },
        },
        h5: {
            ...baseTypography,
            fontWeight: 600,
            fontSize: '1.375rem',
            lineHeight: '130%',
            [`@media only screen and (max-width: ${breakpoints.values.sm}px )`]: {
                fontSize: '1.125rem',
                lineHeight: '135%',
            },
        },
        h6: {
            ...baseTypography,
            fontWeight: 600,
            fontSize: '1.125rem',
            lineHeight: '135%',
            [`@media only screen and (max-width: ${breakpoints.values.sm}px )`]: {
                fontSize: '1rem',
                lineHeight: '145%',
            },
        },
        subtitle1: {
            ...baseTypography,
            fontWeight: 600,
            fontSize: '.9375rem',
            lineHeight: '145%',
        },
        subtitle2: {
            ...baseTypography,
            fontWeight: 600,
            fontSize: '.8125rem',
            lineHeight: '150%',
        },
        sectionTitle: {
            ...baseTypography,
            borderBottom: '1px solid grey',
        },
        body1: {
            ...baseTypography,
            fontSize: '.9375rem',
            lineHeight: '145%',
        },
        body2: {
            ...baseTypography,
            fontSize: '.8125rem',
            lineHeight: '150%',
        },
        button: {
            ...baseTypography,
            fontWeight: 600,
            fontSize: '.8125rem',
            lineHeight: '150%',
            letterSpacing: 1,
            textTransform: 'uppercase',
        },
        caption: {
            ...baseTypography,
            fontSize: '.75rem',
            lineHeight: '150%',
        },
        statusLabel: {
            ...baseTypography,
            fontWeight: 600,
            fontSize: '.75rem',
            lineHeight: '150%',
            letterSpacing: 0.7,
            textTransform: 'uppercase',
        },
        overline: {
            ...baseTypography,
            fontSize: '.625rem',
            lineHeight: '150%',
            textTransform: 'uppercase',
            letterSpacing: 1.3,
        },
    };
};
